// frontend/src/components/Sidebar.js

import React, { useState } from "react";
import { Link } from "react-router-dom";

export default function Sidebar({ currentUser, isAdmin }) {
  const [open, setOpen] = useState(false);

  const userPseudo = currentUser?.pseudo || currentUser?.user?.pseudo || "";

  return (
    <>
      <button
        className="sidebar-toggle"
        onClick={() => setOpen(!open)}
      >
        ☰
      </button>

      <div
        onClick={() => setOpen(false)}
        className={`sidebar-overlay ${open ? "open" : ""}`}
      />

      <div className={`sidebar ${open ? "open" : ""}`}>
        <h3 className="sidebar-title">Menu</h3>

        <Link to="/" onClick={() => setOpen(false)}>Accueil</Link>
        <Link to="/feed" onClick={() => setOpen(false)}>Pour toi</Link>
        <Link to="/friends" onClick={() => setOpen(false)}>Amis</Link>
        <Link to={`/user/${userPseudo}`} onClick={() => setOpen(false)}>Profil</Link>
        <Link to="/messages" onClick={() => setOpen(false)}>Messages</Link>
        <Link to="/coffre" onClick={() => setOpen(false)}>💰 Coffre</Link>

        {isAdmin && (
          <Link to="/admin" onClick={() => setOpen(false)}>🛠 Admin</Link>
        )}

        {currentUser && (
          <button
            className="sidebar-logout"
            onClick={() => {
              localStorage.removeItem("currentUser");
              window.location.assign("/login");
            }}
          >
            Déconnexion
          </button>
        )}
      </div>
    </>
  );
}
